<template>
  <div id="tac-admin-category">
    <router-view />
    <vue-progress-bar></vue-progress-bar>
  </div><!-- #tac-admin-category -->
</template>

<script>
  export default {
  }
</script>
